import 'vuetify/src/components/VDialog/VDialog.sass';

import VDialog from 'vuetify/lib/components/VDialog/VDialog';
import mixins from 'vuetify/lib/util/mixins';
import { convertToUnit } from 'vuetify/lib/util/helpers';
const baseMixins = mixins(VDialog);

export default baseMixins.extend({
  props: {
    top: {
      type: [String, Number],
      default: '62',
    },
    left: {
      type: [String, Number],
      default: 'none',
    },
    minHeight: {
      type: [String, Number],
      default: '455',
    },
  },
  computed: {
    classes() {
      return {
        [`v-dialog ${this.contentClass}`.trim()]: true,
        'v-dialog--active': this.isActive,
        'v-dialog--persistent': this.persistent,
        'v-dialog--fullscreen': this.fullscreen,
        'v-dialog--scrollable': this.scrollable,
        'v-dialog--animated': this.animate,
        'preference-dialog': true,
      };
    },
  },
  methods: {
    genInnerContent() {
      const data = {
        class: this.classes,
        ref: 'dialog',
        directives: [
          {
            name: 'click-outside',
            value: {
              handler: this.onClickOutside,
              closeConditional: this.closeConditional,
              include: this.getOpenDependentElements,
            },
          },
          {
            name: 'show',
            value: this.isActive,
          },
        ],
        style: {
          transformOrigin: this.origin,
        },
      };

      if (!this.fullscreen) {
        data.style = {
          ...data.style,
          maxWidth: this.maxWidth === 'none' ? undefined : convertToUnit(this.maxWidth),
          width: this.width === 'auto' ? undefined : convertToUnit(this.width),
          top: this.top === 'none' ? undefined : convertToUnit(this.top),
          left: this.left === 'none' ? undefined : convertToUnit(this.left),
          position: this.top !== 'none' || this.top !== 'none' ? 'absolute' : undefined,
          minHeight: this.minHeight === 'none' ? undefined : convertToUnit(this.minHeight),
        };
      }

      return this.$createElement('div', data, this.getContentSlot());
    },
  },
});
